module.exports = __webpack_public_path__ + "static/media/16UNODC19.331253da.jpg";